<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_balances'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="fs-4 ps-2 mb-1">Summary
              <i v-if="view_summary" @click.prevent="view_summary = !view_summary" class="mdi mdi-eye"
                style="cursor: pointer"></i>
              <i v-else @click.prevent="view_summary = !view_summary" class="mdi mdi-eye-off"
                style="cursor: pointer"></i>
            </div>
            <div v-if="view_summary" class="row mb-3">
              <div class="col-4 px-3">
                <div class="bg-primary rounded shadow-lg">
                  <div class="p-3">
                    <span class="text-white">Current Savings:</span>
                    <h4 class="text-white">{{ commas(totalCurrentSavings) }}/=</h4>
                    <!-- <span class="text-white">Total Savings:</span>
                    <h4 class="text-white">{{ commas(totalTotalSavings) }}/=</h4> -->
                  </div>
                </div>
              </div>
              <div class="col-4 px-2">
                <div class="bg-dark rounded shadow-lg">
                  <div class="p-3">
                    <!-- <span class="text-white">Total Shares: &nbsp; {{ commas(totalNumberOfShares) }}</span>
                    <h4 class="text-white mb-2">{{ commas(totalValueOfShares) }}/=</h4> -->
                    <span class="text-white">Total Withdraws:</span>
                    <h4 class="text-white">{{ commas(totalWithdraws) }}/=</h4>
                  </div>
                </div>
              </div>
              <div class="col-4 px-2">
                <div class="bg-info rounded shadow-lg">
                  <div class="p-3">
                    <span class="text-white">Running Loans:</span>
                    <h4 class="text-white">{{ commas(totalRunningLoans) }}/=</h4>
                    <!-- <span class="text-white">Total Loans:</span>
                    <h4 class="text-white">{{ commas(totalTotalLoans) }}/=</h4> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">

                <template #thead-top="data">
                  <b-tr>
                    <!-- <b-th colspan="2"><span class="sr-only"></span></b-th> -->
                    <b-th variant="white" colspan="1">#</b-th>
                    <b-th variant="white" colspan="1">Member</b-th>
                    <b-th variant="info" colspan="3" class="text-center">Savings</b-th>
                    <b-th variant="danger" colspan="2" class="text-center">Loans</b-th>
                    <b-th variant="white">Shares</b-th>
                  </b-tr>
                </template>

                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>

                <template #cell(total_shares)="data">
                  <span>{{ data.item.total_shares.shares }} shares</span>
                  <small class="text-primary fw-bold d-block"> {{ commas(data.item.total_shares.amount) }}/=</small>
                </template>

                <template #cell(current_savings)="data">
                  <span class="text-info">{{ commas(data.item.current_savings) }}/=</span>
                </template>

                <template #cell(total_savings)="data">
                  <span class="fw-bold">{{ commas(data.item.total_savings) }}/=</span>
                </template>

                <template #cell(withdraws)="data">
                  <span class="">{{ commas(data.item.withdraws) }}/=</span>
                </template>

                <template #cell(running_loans)="data">
                  <span class="text-danger">{{ commas(data.item.running_loans) }}/=</span>
                </template>

                <template #cell(total_loans)="data">
                  <span class="fw-bold">{{ commas(data.item.total_loans) }}/=</span>
                </template>

              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Account Balances</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { accountbalanceMethods, accountbalanceComputed } from "@/state/helpers";

export default {
  page: {
    title: "Account Balances",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Account Balances",
      items: [{ text: "Dashboard", to: "/", }, { text: "Account Balances", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '', visible: true },
        { key: 'member', label: '', visible: true },
        { key: 'current_savings', label: 'Current', visible: true },
        { key: 'total_savings', label: 'Total', visible: true },
        { key: 'withdraws', label: 'Withdraws', visible: true },
        { key: 'running_loans', label: 'Running', visible: true },
        { key: 'total_loans', label: 'Total', visible: true },
        { key: 'total_shares', label: '', visible: true },
      ],
      name_hover: false,
      current_index: null,
      view_summary: true,
    };
  },
  computed: {
    ...accountbalanceComputed,
    List() { return this.accountbalances.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.accountbalances.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.accountbalances.length > 0) { a = false; } else { a = true; } return a },
    totalCurrentSavings() { return this.accountbalances.reduce((a, b) => a + Number(b.current_savings), 0) },
    totalTotalSavings() { return this.accountbalances.reduce((a, b) => a + Number(b.total_savings), 0) },
    totalNumberOfShares() { return this.accountbalances.reduce((a, b) => a + Number(b.total_shares.shares), 0) },
    totalValueOfShares() { return this.accountbalances.reduce((a, b) => a + Number(b.total_shares.amount), 0) },
    totalWithdraws() { return this.accountbalances.reduce((a, b) => a + Number(b.withdraws), 0) },
    totalRunningLoans() { return this.accountbalances.reduce((a, b) => a + Number(b.running_loans), 0) },
    totalTotalLoans() { return this.accountbalances.reduce((a, b) => a + Number(b.total_loans), 0) },
  },
  mounted() {
    this.fetchAccountBalances();
    this.TotalRows = this.accountbalances.length;
    this.isBusy = false;
  },
  methods: {
    ...accountbalanceMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
};
</script>